<template>
  <div class="bg-white p-8">
    <el-dialog
      title=""
      :visible.sync="centerDialogVisibleg"
      :before-close="handleclose"
      width="45%"
      center
    >
      <template slot="title">
        <h2 class="text-lg text-left text-white font-semibold">Add Category</h2>
      </template>
      <el-form :model="form" :rules="rules" ref="form">
        <div>
          <div class="mb-6">
            <lable>Category Name</lable>
            <el-form-item
              prop="name"
              class=""
              :rules="[
                {
                  required: true,
                  message: ' name cannot be Empty.',

                  trigger: 'blur',
                },
                {
                  pattern: /^[a-zA-Z ]*$/,
                  message: ' name must Contain Alpahbets only',

                  trigger: 'blur',
                },
              ]"
            >
              <el-input
                placeholder="Enter"
                v-model="form.name"
                class="rounded-none mt-2 w-full"
              ></el-input>
            </el-form-item>
          </div>
          <div class="mb-3">
            <lable> Category Icon</lable>
            <el-upload
              class="upload-demo w-full mt-3"
              drag
              ref="imageUploader"
              accept="image/*"
              :before-upload="handleuploadcoverimage"
              single
            >
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">
                Drop file here or <em>click to upload</em>
              </div>
              <div class="el-upload__tip" slot="tip">
                jpg/png files with a size less than 500kb
              </div>
            </el-upload>
          </div>
          <div v-if="renderedImage != null && files != ''" class="relative">
            <img
              :src="renderedImage"
              alt="preview image"
              class="w-full bg-gray object-contain h-60"
            />
            <div class="absolute top-2 right-4 bg-white rounded-full p-1">
              <feather-icon
                icon="XIcon"
                svgClasses="w-4 h-4"
                class="cursor-pointer"
                @click="handlesingleimage"
              />
            </div>
          </div>
          <div
            v-if="imageUrl != '' && imageUrl != 'undefined'"
            class="relative"
          >
            <img
              :src="imageURL + imageUrl"
              alt="preview image"
              class="w-full bg-gray object-contain h-60"
            />
            <div class="absolute top-2 right-4 bg-white rounded-full p-1">
              <feather-icon
                icon="XIcon"
                svgClasses="w-4 h-4"
                class="cursor-pointer"
                @click="imageUrl = ''"
              />
            </div>
          </div>
          <div class="mb-3">
            <lable>Description</lable>
            <el-form-item
              prop="description"
              class=""
              :rules="[
                {
                  required: true,
                  message: ' Description cannot be Empty.',
                  trigger: 'blur',
                },
              ]"
            >
              <quill-editor
                v-model="form.description"
                :options="editorOption"
                class="quill-h200px mt-2"
              />
            </el-form-item>
          </div>
          <div class="flex mt-6 justify-center" v-if="updateres == true">
            <vs-button
              variant="primary"
              class="rounded-full bg-primary border-0 text-white font-semibold py-3 px-8 sm-fsize14"
              @click="handleupdaterecord"
            >
              Update
            </vs-button>
          </div>
          <div class="flex mt-6 justify-center" v-else>
            <vs-button
              variant="primary"
              class="rounded-lg bg-primary border-0 text-white font-semibold py-3 px-8 sm-fsize14"
              @click.prevent="handleCategoryError('form')"
            >
              Submit
            </vs-button>
          </div>
        </div>
      </el-form>
    </el-dialog>
    <div class="flex justify-end w-full">
      <div class="flex items-center gap-2">
        <vs-button
          variant="primary"
          @click="centerDialogVisibleg = true"
          class="rounded-lg bg-primary border-0 text-white font-semibold lg:py-4 md:py-3 py-2 px-8 sm-fsize14"
        >
          Add Categories
        </vs-button>
      </div>
    </div>
    <div class="mt-4">
      <div class="relative">
        <el-input
          placeholder="Search"
          v-model="search"
          class="rounded-none w-full"
        ></el-input>
        <div class="absolute top-0 right-0 mt-2 mr-2">
          <feather-icon icon="SearchIcon" class="" />
        </div>
      </div>
    </div>
    <div class="mt-4">
      <el-table
        :data="elearncategoryData[0].paginatedresult"
        border
        style="width: 100%"
        class="table-responsive table-flush mt-6 cust-overflow-x-primary-color"
        header-row-class-name="thead-light table-th-color"
      >
        <el-table-column prop="city" label="Sr No." min-width="50px">
          <template v-slot="{ row }">
            <P class="text-gray"> {{ row.errorid }}</P>
          </template>
        </el-table-column>
        <el-table-column prop="city" label="Category" min-width="50px">
          <template v-slot="{ row }">
            <P class="text-gray"> {{ row.name }}</P>
          </template>
        </el-table-column>
        <el-table-column prop="city" label="No. of Cources" min-width="50px">
          <template slot-scope="">
            <P class="text-gray"> 0</P>
          </template>
        </el-table-column>

        <el-table-column prop="city" label="Description" min-width="50px">
          <template v-slot="{ row }">
            <P class="text-gray" v-html="row.description"> </P>
          </template>
        </el-table-column>
        <el-table-column prop="city" label="Icons" min-width="50px">
          <template v-slot="{ row }">
            <img alt="icon" :src="imageURL + row.image" class="w-10 h-10" />
          </template>
        </el-table-column>

        <el-table-column prop="city" label="Actions" min-width="40px">
          <template v-slot="{ row }">
            <div class="flex gap-1 items-center">
              <feather-icon
                icon="EditIcon"
                svgClasses="w-4 h-4"
                class="cursor-pointer"
                @click="handleupdate(row)"
              />

              <feather-icon
                icon="TrashIcon"
                svgClasses="w-4 h-4"
                class="cursor-pointer"
                @click="hnadledelete(row)"
              />
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div
      class="w-full flex justify-end mt-6"
      v-if="elearncategoryData[0].totalcount.length > 0"
    >
      <el-pagination
        pills
        :total="Number(elearncategoryData[0].totalcount[0].count)"
        layout="prev,pager,next"
        background
        :current-page="currentPage"
        @current-change="handlePageChange"
        size="sm"
      ></el-pagination>
    </div>
  </div>
</template>
<script>
import Swal from "sweetalert2";
import { mapState } from "vuex";
import { quillEditor } from "vue-quill-editor";
import "quill/dist/quill.bubble.css";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
export default {
  components: {
    quillEditor,
  },
  data() {
    return {
      resid: null,
      updateres: false,
      input: "",
      currentPage: 1,
      search: "",
      offset: null,
      centerDialogVisibleg: false,
      imageUrl: "",
      form: {
        name: "",
        description: "",
      },
      files: "",
      renderedImage: "",
      tableData: [
        {
          date: "20 December 2019",
          name: "Tom",
          state: "PR-1",
          city: "Active",
          address: "No. 189, Grove St, Los Angeles",
          zip: "CA 90036",
        },
        {
          date: "20 December 2019",
          name: "Tom",
          state: "PR-1",
          city: "Active",
          address: "No. 189, Grove St, Los Angeles",
          zip: "CA 90036",
        },
        {
          date: "20 December 2019",
          name: "Tom",
          state: "PR-1",
          city: "Active",
          address: "No. 189, Grove St, Los Angeles",
          zip: "CA 90036",
        },
        {
          date: "20 December 2019",
          name: "Tom",
          state: "PR-1",
          city: "Active",
          address: "No. 189, Grove St, Los Angeles",
          zip: "CA 90036",
        },
        {
          date: "20 December 2019",
          name: "Tom",
          state: "PR-1",
          city: "Active",
          address: "No. 189, Grove St, Los Angeles",
          zip: "CA 90036",
        },
        {
          date: "20 December 2019",
          name: "Tom",
          state: "PR-1",
          city: "Active",
          address: "No. 189, Grove St, Los Angeles",
          zip: "CA 90036",
        },
        {
          date: "20 December 2019",
          name: "Tom",
          state: "PR-1",
          city: "Active",
          address: "No. 189, Grove St, Los Angeles",
          zip: "CA 90036",
        },
      ],
    };
  },

  computed: {
    ...mapState("eLearningCategory", ["elearncategoryData"]),
    imageURL() {
      return "https://nimbus-server-01.s3.ap-south-1.amazonaws.com";
    },
  },
  watch: {
    search() {
      this.getAllCategory();
    },
  },
  methods: {
    handleCategoryError(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          return this.handleSumbit();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    reset() {
      this.form.name = "";
      this.form.description = "";
      this.files = "";
      this.renderedImage = null;
      this.imageUrl = "";
    },
    handleclose() {
      this.centerDialogVisibleg = false;
      this.updateres = false;
      this.reset();
      this.$refs["form"].resetFields();
    },
    async handleupdaterecord() {
      try {
        const payload = new FormData();
        // if (this.files == "" && this.imageUrl=="")
        //     return this.getmessage("Please Select Image", "warning")
        payload.append("name", this.form.name);
        payload.append("description", this.form.description);
        payload.append("image", this.files);
        payload.append("_id", this.resid);
        console.log(payload);
        let data = await this.$store.dispatch(
          "eLearningCategory/UpdateCategory",
          payload
        );
        if (data.code == 200) {
          await this.getAllCategory();
          this.centerDialogVisibleg = false;
          this.updateres = false;
          this.getmessage("recorded Updated", "success");
        }
      } catch (err) {
        console.log(err);
      }
    },
    async handleupdate(row) {
      this.centerDialogVisibleg = true;
      console.log(row, "rowrowrow");
      (this.form.name = row.name), (this.form.description = row.name);
      this.imageUrl = row.image;
      this.updateres = true;
      this.resid = row._id;
    },
    getmessage(message, type) {
      this.$swal({
        text: message,
        icon: type,
        confirmButtonColor: "#cd3197",
        confirmButtonText: "Okay",
      });
    },
    ConfirmDelete() {
      return Swal.fire({
        title: `Are you sure you want to delete this ?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#335080",
        cancelButtonColor: "#000000",
        confirmButtonText: "Yes",
      });
    },
    async hnadledelete(row) {
      let res = await this.ConfirmDelete();
      if (res.isConfirmed) {
        try {
          let payload = {
            _id: row._id,
            isActive: false,
          };
          let data = await this.$store.dispatch(
            "eLearningCategory/UpdateCategory",
            payload
          );
          if (data.code == 200) {
            this.getmessage("Record Deleted", "success");
            await this.getAllCategory();
          }
        } catch (error) {
          console.log(error);
        }
      }
    },
    async handlePageChange(value) {
      this.currentPage = value;

      this.offset =
        this.currentPage > 1 ? (this.currentPage - 1) * 10 : this.currentPage;
      this.getAllCategory();
    },
    handlesingleimage() {
      this.renderedImage = null;
      this.files = "";
    },
    async handleuploadcoverimage(files) {
      this.files = files;
      console.log(this.files, "length");
      await this.readerData(files);
    },
    readerData(rawFile) {
      const reader = new FileReader();
      reader.onload = (e) => {
        this.$emit("load", (this.renderedImage = e.target.result));
      };
      reader.readAsDataURL(rawFile);
    },
    async getAllCategory() {
      try {
        const payload = {};
        if (this.offset != null) {
          Object.assign(payload, { offset: this.offset });
        }
        if (this.search != "") {
          Object.assign(payload, { search: this.search });
        }
        await this.$store.dispatch("eLearningCategory/getAllCategory", payload);
        console.log("elearncategoryData", this.elearncategoryData);
      } catch (error) {
        console.log(error);
      }
    },
    async handleSumbit() {
      const payload = new FormData();
      if (this.files == "")
        return this.getmessage("Please Select Image", "warning");
      payload.append("name", this.form.name);
      payload.append("description", this.form.description);
      payload.append("image", this.files);

      console.log(payload);
      let data = await this.$store.dispatch(
        "eLearningCategory/createCategory",
        payload
      );
      if (data.code == 200) {
        this.centerDialogVisibleg = false;
        this.getAllCategory();
        this.getmessage("record Added", "success");
      }
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },
    handleClick(name) {
      this.$router.push({ name: name });
    },
  },
  async mounted() {
    await this.getAllCategory();
  },
};
</script>
